<template>
  <div class="loading-container grid-y align-center" :class="isInline">
    <div class="grid-x">
      <div class="cell small-12 center">
        <img :class="fallbackClass" :src="loadingImg">
      </div>
    </div>
    <div class="loading-fact grid-x" v-if="slotHasContent">
      <div class="cell small-12 center">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
import browser from '@/services/BrowserEvalService';

export default {
  name: 'loading-element',
  props: {
    /**
     * If inline is true, then the padding around the loading image will not be added
     * Example: <loading-slide inline></loading-slide>
     */
    inline: Boolean
  },
  computed: {
    fallbackClass() {
      return {
        fallback: this.imageType === 'gif'
      };
    },
    isInline() {
      return {
        inline: this.inline
      };
    },
    loadingImg() {
      let images;
      if (browser.isIE || browser.isEdge) {
        this.imageType = 'gif';
        images = require.context('../../assets', false, /\.gif$/);
      } else {
        this.imageType = 'svg';
        images = require.context('../../assets', false, /\.svg$/);
      }
      return images(`./loading-circles.${this.imageType}`);
    },
    slotHasContent() {
      return !!this.$slots.default;
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/variables.scss';

.loading-container {
  &:not(.inline) {
    min-height: 27.475rem;
    @include breakpoint (medium only) {
      min-height: 19rem;
    }
    @include breakpoint (small only) {
      min-height: 16.5rem;
    }
    .loading-fact {
      margin-top: 2.5rem;
    }
  }
  img {
    width: 2.75rem;

    &:not(.fallback) {
      height: auto;
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/components/shared/loading-element.vue